import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type SideContentContainerProps = {
	className?: string;
	children: any;
};

export const SideContentContainer = ({
	children,
	className,
}: SideContentContainerProps) => {
	return (
		<div className={clsx(styles.sideContentContainer, className)}>
			{children}
		</div>
	);
};
